import { motion } from "framer-motion";
import ApiServices from "../../../service/ApiServices";
import { defer, useLoaderData, Await} from "react-router-dom";
import { Suspense } from "react";
import { Spinner } from "../../template/spinner/spinner";
import { useCart } from "../../../app/context/cart-context/cart-context";

import './product.css';
import { BackButton } from "../../template/buttons/back-btn/back-btn";
import { AddToCartBtn } from "../../template/buttons/add-to-cart-btn/add-to-cart-btn";
import { QuantitySelector } from "../../template/inputs/quantity-selector/quantity-selector";


const Product = () => {
    const {product} = useLoaderData();

    const { cart } = useCart();

    return (
        <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.5 } }}
        exit={{ opacity: 0 }}
        >
                <Suspense fallback={ <Spinner/> }>
                    <Await resolve={product}>
                        
                        {(product) => (
                            <>
                                <div className="image-wrap mb-2">
                                    <BackButton/>
                                    {"img" in product && product.img &&
                                                <img src={product.img} alt={product.name} />
                                    }
                                </div>
                                <div className="container-fluid">
                                    <div className="row mb-2 pb-1 border-bottom">
                                        <div className="col-12">
                                            <div className="row mb-2">
                                                <div className="col-8 fs-6 fw-bold">{product.name}</div>
                                                <div className="col-4 fs-6 fw-bold text-end"><span>{product.price} грн</span></div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12fs-6 ">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, ad!</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col d-flex justify-content-end">
                                            {cart.every(item => item.id !== product.id) ?
                                                <AddToCartBtn productId={product.id}/>
                                                :
                                                <QuantitySelector productId={product.id}/>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </Await>
                </Suspense>
        </motion.div>
    )
}

const res = new ApiServices();

const productLoader = async ({params}) => {
    const {id} = params;
    return defer({
        product: res.getProductsById(id),
    })
}

export {Product, productLoader};